export function setRequest(request) {
  return {
    type: 'SET_REQUEST',
    request
  };
}
export function setRequestPDP(requestPDP) {
  return {
    type: 'SET_REQUEST_PDP',
    requestPDP
  };
}
export function setLocation(location) {
  return {
    type: 'SET_LOCATION',
    location_details: location
  };
}

export function setDeviceType(deviceType) {
  return {
    type: 'SET_DEVICETYPE',
    deviceType: (deviceType === 'phone' || deviceType === 'tablet') ? 'mobile' : 'desktop'
  }
}

export function renderingInfo(info) {
  return {
    type: 'SET_RENDERING_INFO',
    info
  };
}
